var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"p-0",attrs:{"type":"text","disabled":_vm.isLoading},on:{"click":_vm.toggleLock}},[_c(_vm.currentIcon,{tag:"component",attrs:{"height":"25","width":"20","iconColor":_vm.iconColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }